import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StepsComponent } from 'src/app/shared/components/steps/steps.component';
import { IDeliveryService } from 'src/app/shared/interfaces/deliveryService/ideliveryService';
import { IProfessionalService } from 'src/app/shared/interfaces/profissional/iprofessionalservice';
import { ModalService } from 'src/app/shared/services/modal.service';
import {
  editDeliveryService,
  saveDeliveryService,
} from 'src/app/store/delivery-service/delivery-service.actions';
import { loadProfessionalService } from 'src/app/store/professional-service/professional-service.actions';
import { selectProfessionalServicoLista } from 'src/app/store/professional-service/professional-service.selectors';
import { loadProfessional } from 'src/app/store/professional/professional.actions';
import { selectProfessionalLista } from 'src/app/store/professional/professional.selectors';

@Component({
  selector: 'app-dados-servicos-form',
  templateUrl: './dados-servicos-form.component.html',
  styleUrls: ['./dados-servicos-form.component.scss'],
})
export class DadosServicosFormComponent {
  @ViewChild('steps') steps!: StepsComponent;

  seviceSelected!: IProfessionalService; //variavel importante
  professionalService$ = this.store.select(selectProfessionalServicoLista);
  professionals$ = this.store.select(selectProfessionalLista);
  servicos: IProfessionalService[] = [];

  employee: any = [
    { name: 'Ana Silva' },
    { name: 'Roberta Lima' },
    { name: 'Tiago Martins' },
    { name: 'Fernanda Rocha' },
  ];

  deliveryTime: any = [
    {
      nome: '1 dia',
    },
    {
      nome: '2 dias',
    },
    {
      nome: '3 dias',
    },
    {
      nome: '4 dias',
    },
    {
      nome: '5 dias',
    },
    {
      nome: '6 dias',
    },
    {
      nome: '7 dias',
    },
    {
      nome: '8 dias',
    },
    {
      nome: '9 dias',
    },
    {
      nome: '10 dias',
    },
  ];

  form: FormGroup = this.fb.group({
    // service: ['', Validators.required],
    employee: [[''], Validators.required],
    deliveryTime: ['', Validators.required],
  });

  id: number = 0;

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private modalService: ModalService,
    private store: Store<IDeliveryService>,
    private config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadProfessional());
    this.store.dispatch(loadProfessionalService());
    this.professionalService$.subscribe(res => {
      this.servicos = res;
    })
    if (this.config.data && this.config.data.item) {
      this.id = this.config.data.item.id;
      this.popularFormulario(this.config.data.item);
    }
  }
  //form functions
  popularFormulario(item: IDeliveryService) {
    this.seviceSelected = item.service;
    this.form.controls['employee'].setValue(item.professional);
    this.form.controls['deliveryTime'].setValue(item.delivery);
  }

  //modal functions
  saveForm() {
    const req: IDeliveryService = {
      client: "/api/clients/1",
      service: this.seviceSelected,
      professional: this.form.value.employee,
      delivery: this.form.value.deliveryTime,
    };

    if (this.id) {
      this.store.dispatch(
        editDeliveryService({ deliveryService: req, id: this.id })
      );
    } else {
      this.store.dispatch(saveDeliveryService({ deliveryService: req }));
    }

    this.closeForm();
  }
  closeForm() {
    this.ref.close();
  }
  selectService(selected: IProfessionalService) {
    this.steps.nextStep();
    this.seviceSelected = selected;
  }
  changeTitle(index: number) {
    if (index == 0) {
      this.modalService.changeHeader('Selecione o Serviço:');
    } else {
      this.modalService.changeHeader('Especialidades:');
    }
  }
}
